import { useCallback } from 'react'
import isEmpty from 'lodash/isEmpty'
import forEach from 'lodash/forEach'
import cloneDeep from 'lodash/cloneDeep'

import { useStateValue } from '../../../services/state/StateProvider'
import { config } from '../../../components/Init/Init'
import getTout from '../../../services/content/supportedTouts'
import { areTagsValidForThisGame } from '../../../services/utils'
import { usePlayerStore } from '../../../services/store'

export const useUpdateRecentlyPlayedGames = () => {
  const [{ casino }] = useStateValue()

  const playerStore = usePlayerStore()
  const playerTagsGames = playerStore.use.tagsGames()

  const updateRecentlyPlayedGames = useCallback(
    ({ categories, previousGames }) => {
      const categoriesCopy = [...categories]
      if (!isEmpty(categoriesCopy) && previousGames !== null && previousGames.length !== 0) {
        const numPreviousGames = previousGames.length

        // add recently played games category
        categoriesCopy.splice(1, 0, config.prevGames)

        const recentlyPlayedCategory = categoriesCopy.find(category => category.id === config.prevGames.id)

        if (recentlyPlayedCategory) {
          recentlyPlayedCategory.touts = []

          for (let i = 0; i < numPreviousGames; i++) {
            const newTout = cloneDeep(getTout())
            recentlyPlayedCategory.touts.push(newTout)
          }

          forEach(recentlyPlayedCategory.touts, (recentlyPlayedGameTouts, index) => {
            if (previousGames[index] !== undefined) {
              const gameId = previousGames[index]
              if (
                casino.games &&
                casino.games[gameId] &&
                casino.games[gameId].title !== undefined &&
                recentlyPlayedGameTouts[0].asset &&
                recentlyPlayedGameTouts[0].asset.title !== undefined &&
                (!config.filterGamesForPlayerTags || areTagsValidForThisGame(playerTagsGames, casino.games[gameId]))
              ) {
                recentlyPlayedGameTouts[0].asset.title = casino.games[gameId].title
                recentlyPlayedGameTouts[0].asset.id = casino.games[gameId].id
                recentlyPlayedGameTouts[0].asset.provider = casino.games[gameId].provider
                recentlyPlayedGameTouts[0].asset.secondProvider = casino.games[gameId].secondProvider
              }
            }
          })

          const filterGames = recentlyPlayedCategory.touts.filter(value => {
            if (value[0].asset.title !== '{title}') {
              return value
            }
            return null
          })

          recentlyPlayedCategory.touts = Array.from(new Set(filterGames.map(JSON.stringify)), JSON.parse)

          recentlyPlayedCategory.totalCount = recentlyPlayedCategory.touts.length
          recentlyPlayedCategory.totalCountWithSubcategories = recentlyPlayedCategory.touts.length
        }
      }

      return categoriesCopy
    },
    [casino.games, playerTagsGames]
  )

  return { updateRecentlyPlayedGames }
}
